import React from 'react';
import { connect } from 'react-redux';
import { Modal, Spin } from 'antd';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ChatModalWrapper from './ConversationModal.style';
import { toggleConversationPopup, replyToConversation } from '../../../redux/actions/Box/BoxActions';

class ChatModal extends React.Component {
  
  constructor() {
    super();
    this.closeChatModal = this.closeChatModal.bind(this);
    this.handleChatReply = this.handleChatReply.bind(this);
  }

  closeChatModal() {
    this.props.toggleConversationPopup(false);
  }

  handleChatReply(e) {
    e.preventDefault();
    e.persist();
    const messageText = e.target.messageText.value;
    console.log(messageText);
    this.props.replyToConversation(this.props.BOXREDUCER.conversation_user.id,this.props.BOXREDUCER.conversation_report.report_id,messageText,e);
  }
  
  render() {

    let _formMessage = this.props.BOXREDUCER.conversation_data.map((msg) => {
      if(msg.hasOwnProperty('receiver')) {
        if (msg.receiver != -1) {
          return (
            <div className="flex support-msg-body">
              <div className="initials">M</div>
              <div className="flex support-msg">
                <p>{ReactHtmlParser(msg.message)}</p>
              </div>
            </div>
          )
        }
        else {
          return (
            <div className="flex client-msg-body">
              <div className="initials">C</div>
              <div className="flex client-msg">
                <p>{ReactHtmlParser(msg.message)}</p>
              </div>
            </div>
          )
        }
      }
      else {
        return (
          <div className="flex client-msg-body">
            <div className="initials">C</div>
            <div className="flex client-msg">
              <p>{ReactHtmlParser(msg.customization)}</p>
            </div>
          </div>
        )
      }
    })

    return(
      <ChatModalWrapper>
        <Modal
          visible={this.props.BOXREDUCER.conversation_popup_visible}
          title={<h3 className="conversation-header">{this.props.BOXREDUCER.conversation_report.hasOwnProperty('title') ? this.props.BOXREDUCER.conversation_report.title : ''}</h3>}
          onOk={this.closeChatModal}
          onCancel={this.closeChatModal}
          className="chat-modal"
          footer={[
            <form className="flex chat-message-form" onSubmit={(e) => this.handleChatReply(e)}>
              <input placeholder="Enter Message Here" name="messageText" />
              <button type="submit" className="send-icon"><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="#263238" fill-opacity=".45" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg></button>
            </form>
          ]}
        > 
          <Spin spinning={this.props.BOXREDUCER.conversation_data_loading} tip="Loading Messages...">
            <div className="flex chat-message-list">
              {_formMessage}
            </div>
          </Spin>
        </Modal>
      </ChatModalWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  toggleConversationPopup,
  replyToConversation
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatModal);


// WEBPACK FOOTER //
// ./src/components/Box/ConversationModal/ConversationModal.js